import { render, staticRenderFns } from "./formulario2.vue?vue&type=template&id=3f2a3afc"
import script from "./formulario2.vue?vue&type=script&lang=js"
export * from "./formulario2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports